import { render } from "./adminLayout.vue?vue&type=template&id=e7225530"
import script from "./adminLayout.vue?vue&type=script&lang=js"
export * from "./adminLayout.vue?vue&type=script&lang=js"

import exportComponent from "D:\\angren\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__